export const fonts = {
  body: "DM Sans, Inter, sans-serif",
  heading: "DM Sans, Inter, sans-serif",
  mono: "Source Code Pro, Inter, sans-serif",
}
